/**
 *
 * @param {Date} date
 * @returns boolean
 */
export const isDateInPast = (then) => {
  if (!then) {
    return false;
  }

  const now = new Date();

  return now >= then;
};
